import { scopes } from '../constants/scopes';
const keys = {
  AI_EMAIL_ENRICHMENT_ADMIN: 'aiEmailEnrichmentAdmin',
  BILLING_ACCESS: 'billingAccess',
  BREEZE_INTELLIGENCE_FREE: 'breezeIntelligenceFree',
  DATA_ENRICHMENT_ACCESS: 'dataEnrichmentAccess',
  CONVERSATIONAL_ENRICHMENT_BASIC: 'conversationalEnrichmentBasic',
  CONVERSATIONAL_ENRICHMENT_FREE: 'conversationalEnrichmentFree',
  CONVERSATIONAL_ENRICHMENT_PREMIUM: 'conversationalEnrichmentPremium',
  ENRICHMENT_CONTINUOUS_ACCESS: 'enrichmentContinuousAccess',
  ENRICHMENT_ONE_TIME_USAGE: 'enrichmentOneTimeUsage',
  ENRICHMENT_PLATFORM_ACCESS: 'enrichmentPlatformAccess',
  ENRICHMENT_UNLIMITED_USAGE: 'enrichmentUnlimitedUsage',
  MANAGE_DATA_ENRICHMENT: 'manageDataEnrichment',
  SUPER_ADMIN: 'superAdmin'
};
const scopeLookup = {
  [keys.AI_EMAIL_ENRICHMENT_ADMIN]: scopes.AI_EMAIL_ENRICHMENT_ADMIN,
  [keys.BILLING_ACCESS]: scopes.BILLING_ACCESS,
  [keys.BREEZE_INTELLIGENCE_FREE]: scopes.BREEZE_INTELLIGENCE_FREE,
  [keys.DATA_ENRICHMENT_ACCESS]: scopes.DATA_ENRICHMENT_ACCESS,
  [keys.CONVERSATIONAL_ENRICHMENT_BASIC]: scopes.CONVERSATIONAL_ENRICHMENT_BASIC,
  [keys.CONVERSATIONAL_ENRICHMENT_FREE]: scopes.CONVERSATIONAL_ENRICHMENT_FREE,
  [keys.CONVERSATIONAL_ENRICHMENT_PREMIUM]: scopes.CONVERSATIONAL_ENRICHMENT_PREMIUM,
  [keys.ENRICHMENT_CONTINUOUS_ACCESS]: scopes.ENRICHMENT_CONTINUOUS_ACCESS,
  [keys.ENRICHMENT_ONE_TIME_USAGE]: scopes.ENRICHMENT_ONE_TIME_USAGE,
  [keys.ENRICHMENT_PLATFORM_ACCESS]: scopes.ENRICHMENT_PLATFORM_ACCESS,
  [keys.ENRICHMENT_UNLIMITED_USAGE]: scopes.ENRICHMENT_UNLIMITED_USAGE,
  [keys.MANAGE_DATA_ENRICHMENT]: scopes.MANAGE_DATA_ENRICHMENT,
  [keys.SUPER_ADMIN]: scopes.SUPER_ADMIN
};
export function getScopes(options) {
  return Object.keys(options).map(option => options[option] ? scopeLookup[option] : null).filter(scope => scope !== null);
}
export function getScope(key) {
  return scopeLookup[key];
}